import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
    palette: {
        primary: {
            main: '#4A6B5D', // Eucalypt Green
            light: '#739688',
            dark: '#344e41',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#8E44AD', // Muted Purple or similar if needed, keeping it minimal
        },
        background: {
            default: '#FAFAFA',
            paper: '#FFFFFF',
        },
        text: {
            primary: '#333333', // Soft Black for readability without harshness
            secondary: '#555555',
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1200,
            xl: 1280, // Global Max Width Constraint
        },
    },
    typography: {
        fontFamily: [
            'Lato', // Clean sans for body
            'sans-serif',
        ].join(','),
        h1: {
            fontFamily: 'Playfair Display, serif',
            fontWeight: 400, // Regular (Lightest available)
            letterSpacing: '0.02em',
        },
        h2: {
            fontFamily: 'Playfair Display, serif',
            fontWeight: 400,
            letterSpacing: '0.02em',
        },
        h3: {
            fontFamily: 'Playfair Display, serif',
            fontWeight: 400,
            letterSpacing: '0.01em',
        },
        h4: {
            fontFamily: 'Playfair Display, serif',
            fontWeight: 400,
        },
        h5: {
            fontFamily: 'Lato, sans-serif',
            fontWeight: 300,
        },
        body1: {
            fontWeight: 300,
            fontSize: '1.05rem',
            lineHeight: 1.7,
        },
        button: {
            fontFamily: 'Lato, sans-serif',
            textTransform: 'none', // Simple, natural text
            fontWeight: 400, // Normal weight, not thin/bold
            letterSpacing: '0.02em',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 4, // Slightly rounded for a friendly, modern feel
                    padding: '10px 24px',
                    boxShadow: 'none', // Flat design
                    textTransform: 'none', // Force disable uppercase
                    '&:hover': {
                        boxShadow: 'none',
                        '& .MuiButton-endIcon': {
                            transform: 'translateX(4px)',
                        },
                    },
                    '& .MuiButton-endIcon': {
                        transition: 'transform 0.2s ease-in-out',
                        '& > svg': {
                            fontSize: '1.1rem', // Scale down icon slightly
                        }
                    },
                },
                // containedPrimary and outlinedPrimary removed to use palette colors
            },
        },
    },
});

theme = responsiveFontSizes(theme);

export default theme;
